import { Fragment } from "react"
import axios from 'axios'
import Cookies from 'js-cookie'
import queryString from 'query-string'
import { toast, Slide } from 'react-toastify'
import qs from 'qs'
import { Check, X, AlertTriangle } from 'react-feather'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { registerLicense } from '@syncfusion/ej2-base'
import _ from "lodash"
import IntlMessageFormat from 'intl-messageformat'
import moment from "moment"
import 'moment/locale/ar'
import 'moment/locale/fr'
import 'moment/locale/de'
//************************************//
import Avatar from '@components/avatar'
import history from '@src/router/history'
import { store } from '@csrc/redux/storeConfig/store'
import { _logout } from "@modules/user"
import { env, _setGlobal, _getGlobal } from './GlobalUtils'


//************************************/
export { env, _setGlobal, _getGlobal }
//************************************/
export const getBackendUrl = () => {
  if (env('REACT_APP_BACKEND_BASE_URL_IS_FULL') !== 'false') {
    if (env('REACT_APP_BACKEND_ADD_HOST_TO_END') === 'true') {
      return `${_.trimEnd(env('REACT_APP_BACKEND_BASE_URL'), '/')}/${window.location.hostname}`
    } else {
      return env('REACT_APP_BACKEND_BASE_URL')
    }
  } else {
    return `${window.location.protocol}//${window.location.hostname}/${env('REACT_APP_BACKEND_BASE_URL')}`
  }
}

//************************************//
export const trans = (id, vars = {}) => {
  const msg = _getGlobal(`messages`)[id] ?? id
  return msg === id ? msg : new IntlMessageFormat(msg).format(vars)
  // return (<FormattedMessage id={id} values={{...vars}} defaultMessage={id}/>)
}

export { history }

const MySwal = withReactContent(Swal)
export const _confirm = (opt = {}) => {
  const {
    title = trans('gen.confirmModal.title'),
    text = trans('gen.confirmModal.text'),
    html = undefined,
    icon = 'warning',
    confirmButtonText = trans('gen.confirmModal.confirmButtonText'),
    cancelButtonText = trans('gen.actions.cancel'),
    width = null,
    showCancelButton = true
  } = opt
  MySwal.fire({
    customClass: {
      confirmButton: 'btn btn-primary',
      cancelButton: 'btn btn-outline-danger ml-1'
    },
    showCancelButton,
    buttonsStyling: false,
    ...opt,
    title,
    text,
    html,
    icon,
    width,
    confirmButtonText,
    cancelButtonText
  }).then(function (result) {
    if (result.value) {
      if (opt.callback) {
        opt.callback(() => {
          MySwal.fire({
            icon: 'success',
            title: trans('gen.confirmModal.callBackTitle'),
            text: '',
            customClass: {
              confirmButton: 'btn btn-success'
            }
          })
        })
      }
    }
  })
}

const ToastContent = ({ type, text }) => {
  let color = type, title, Icon
  if (type === 'error') {

    color = 'danger'
    title = trans('gen.toast.error')
    Icon = X
  } else if (type === 'success') {
    title = trans('gen.toast.success')
    Icon = Check
  } else if (type === 'warning') {
    title = trans('gen.toast.warning')
    Icon = AlertTriangle
  }
  return (
    <Fragment>
      <div className='toastify-header'>
        <div className='title-wrapper'>
          {/* <Avatar size='sm' color={color} icon={<Icon size={12} />} /> */}
          <h6 className='toast-title'>{title}</h6>
        </div>
      </div>
      <div className='toastify-body'>
        <span>{text}</span>
      </div>
    </Fragment>
  )
}
//************************************//
export function _toast(text, type = 'error', autoClose = 5000) {
  if (text === false) {
    toast.dismiss()
    return
  }
  const options = { transition: Slide, hideProgressBar: false, autoClose, type }
  toast(<ToastContent text={text} type={type} />, options)
}
//************************************//
export const getCasConfig = () => {
  const app = store.getState().app.settings.app
  return {
    enabled: app.cas_enabled,
    url: app.cas_url,
    logoutUrl: app.cas_logout_url,
    assertionKey: app.cas_assertion_key,
    targetKey: app.cas_target_key
  }
}

export const getSwitchWorkspaceUrl = (domain) => {
  const { enabled, targetKey, url } = getCasConfig()
  if (enabled) {
    const target = `${window.location.protocol}//${domain}`
    return `${url}?${targetKey}=${encodeURI(target)}`
  } else {
    return '#'
  }
}
export const redirectToCasServer = (to = null) => {
  const { enabled, targetKey, url } = getCasConfig()
  if (enabled) {
    const target = to ? to : `${window.location.protocol}//${window.location.host}`
    window.location.replace(`${url}?${targetKey}=${encodeURI(target)}`)
  }
}

export const redirectToLogoutCasServer = () => {
  const { enabled, logoutUrl } = getCasConfig()
  if (enabled) {
    window.location.replace(logoutUrl)
  }
}
//************************************//
export function _isOnline() {
  return true
}
//************************************//
export function _loading(start, config) {
  store.dispatch({ type: start ? "APP_LOADING_START" : "APP_LOADING_END", payload: config })
}
//************************************//
export function _historyPush(to) {
  history.push(to)
}
//************************************//
function _handleError({ data, status }, config) {
  const code = data.error_code
  if (code === 'USR_UNAUTHENTICATED') {
    _logout(store.dispatch)
    if (!_.includes(['/login', '/register', '/forgot-password'], history.location.pathname)) {
      _historyPush('/login')
      window.location.reload()
    }
  } else if (status === 404 && code !== 'USR_USER_NOT_EXIST') {
    history.replace('/error')
  }
}
//************************************//
function _inProgressApiCount(action) {
  const k = 'inProgressApiCount'
  const c = _getGlobal(k) || 0
  let n = 0
  if (action === '+') {
    n = c + 1
  } else if (action === '-') {
    n = c - 1
    n = n > 0 ? n : 0
  }
  _setGlobal(k, n)
  return { c, n }
}

const API = axios.create({
  baseURL: getBackendUrl(),
  headers: {
    dev: true
  },
  withCredentials: true
})

API.interceptors.request.use(function (config) {
  if (!_isOnline()) {
    if (config.sync) {
      config.silent = true
      throw ({ sync: config.sync, config })
    } else {
      throw ({ offline: true })
    }
  }
  if (config.silent !== true) {
    if (_inProgressApiCount('+').c === 0) {
      _loading(true, { key: config?.headers?.trackingKey ?? config.url })
    }
    //_toast(false)
  }

  if (config.params) {
    config.paramsSerializer = p => {
      return qs.stringify(p)
    }
  }

  if (config.data && !config.noStringify) {
    //config.data = qs.stringify(config.data)
  }
  //console.log(config)
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})
API.interceptors.response.use(
  function (response) {
    if (response.config.silent !== true) {
      if (_inProgressApiCount('-').n === 0) {
        _loading(false, { key: response?.config?.headers?.trackingKey ?? response?.config?.url })
      }
      if (response.data.message) {
        if (response.data.message !== '') {
          _toast(response.data.message, 'success')
        }
      }
    }
    return response.data
  },
  function (error) {
    if (error.config.silent !== true) {
      if (_inProgressApiCount('-').n === 0) {
        _loading(false, { key: error?.config?.headers?.trackingKey ?? error?.config?.url, value: { status: error?.response?.status } })
      }
    }
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      //console.log(error.response.data, error.response.status, error.response)
      if (error.config.silent !== true) {
        if (error.response.data.error !== '') {
          console.log(error.response.data)
          _handleError(error.response, error.config)
          _toast(error.response.data.message, 'error')
        }
      } else {
        console.log(error)
      }

    } else if (error.request) {
      console.log(error.request)
      if (error.request._response) {
        // _toast(error.request._response,'error')
      }
    } else if (error.sync) {
      //_storeSyncRequest(error.config,error.sync)
    } else if (error.offline) {
      //_toast(t('desktop.NO_INTERNET'),'error')
    } else {
      console.log('Error', error.message)
    }
    return Promise.reject(error.response)
  })
export { API }
//************************************//
export const _getUserToken = () => {
  const sessionUserToken = JSON.parse(sessionStorage.getItem('USER_TOKEN'))
  const cookieUserToken = Cookies.get('USER_TOKEN') ? JSON.parse(Cookies.get('USER_TOKEN')) : false
  return (sessionUserToken || cookieUserToken || false)
}
//************************************//
export const _addAuthToUrl = (url, params) => {
  const data = { ...params }
  const queryStringStringify = qs.stringify(data)
  return `${url}?${queryStringStringify}`
  // const user = _getUserToken()
  // if (user) {
  //   const token = user.token
  //   const userId = user.user.id
  //   const data = { t: token, i: userId, ...params }
  //   const queryStringStringify = queryString.stringify(data)
  //   return `${url}?${queryStringStringify}`
  // }
  // return null
}
//************************************//
export function _addBackendHeaderToHttpRequest(httpRequest) {
  httpRequest.withCredentials = true
  httpRequest.setRequestHeader("lang", _getGlobal('APP_LANG'))
  httpRequest.setRequestHeader("X-Xsrf-Token", Cookies.get('XSRF-TOKEN'))
  return httpRequest
}
//************************************//
export function _setAPILang(lang) {
  API.defaults.headers['lang'] = lang
}
//************************************//
export const _getAppLang = (lang) => {
  return _getGlobal('APP_LANG')
}
//************************************//
export const _setAppLang = (lang) => {
  localStorage.setItem('APP_LANG', lang)
  _setGlobal('APP_LANG', lang)
  _setAPILang(lang)
  moment.locale(lang)
}
//************************************//
export const _changeAppLang = (lang) => {
  localStorage.setItem('APP_LANG', lang)
  location.reload()
}
// ** Returns K format from a number
export const kFormatter = num => (num > 999 ? `${(num / 1000).toFixed(1)}k` : num)
//************************************//
// ** Converts HTML to string
export const htmlToString = html => html.replace(/<\/?[^>]+(>|$)/g, '')
//************************************//
// ** Checks if the passed date is today
const isToday = date => {
  const today = new Date()
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  )
}

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (value, formatting = { month: 'short', day: 'numeric', year: 'numeric' }) => {
  if (!value) return value
  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}
//************************************//
// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value)
  let formatting = { month: 'short', day: 'numeric' }

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: 'numeric', minute: 'numeric' }
  }

  return new Intl.DateTimeFormat('en-US', formatting).format(new Date(value))
}
//************************************//
export const isUserLoggedIn = () => (localStorage.getItem('USER_TOKEN'))
export const getUserData = () => (store.getState().user.userData)
export const isRtl = () => (store.getState().layout.isRTL)
//************************************//
/**
 ** This function is used for demo purpose route navigation
 ** In real app you won't need this function because your app will navigate to same route for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = userRole => {
  if (userRole === 'admin') return '/'
  if (userRole === 'client') return '/access-control'
  return '/login'
}

// ** React Select Theme Colors
export const selectThemeColors = theme => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: '#7367f01a', // for option hover bg-color
    primary: '#7367f0', // for selected option bg-color
    neutral10: '#7367f0', // for tags bg-color
    neutral20: '#ededed', // for input border-color
    neutral30: '#ededed' // for input hover border-color
  }
})
//************************************/
export const _url = (uri) => {
  return uri.indexOf('http') > -1 ? uri : `${API.defaults.baseURL}/storage/${uri}`
}
//************************************/
//************************************//
export const _getRestrictions = (rules) => {
  return {
    // maxFileSize: rules.max_size ?? null,
    // minFileSize: null,
    // maxTotalFileSize: rules.max_size ?? null,
    // maxNumberOfFiles: 1,
    // minNumberOfFiles: 1,
    maxFileSize: null,
    minFileSize: null,
    maxTotalFileSize: null,
    maxNumberOfFiles: 1,
    minNumberOfFiles: 1,
    allowedFileTypes: rules.type && rules.type.length > 0 ? _.map(rules.type, x => `.${x}`) : []
  }
}
//************************************/
export const uuidv4 = () => {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}
//************************************/
export const phpToMomentFormat = (str) => {
  const replacements = {
    d: "DD",
    D: "ddd",
    j: "D",
    l: "dddd",
    N: "E",
    S: "o",
    w: "e",
    z: "DDD",
    W: "W",
    F: "MMMM",
    m: "MM",
    M: "MMM",
    n: "M",
    t: "", // no equivalent
    L: "", // no equivalent
    o: "YYYY",
    Y: "YYYY",
    y: "YY",
    a: "a",
    A: "A",
    B: "", // no equivalent
    g: "h",
    G: "H",
    h: "hh",
    H: "HH",
    i: "mm",
    s: "ss",
    u: "SSS",
    e: "zz", // deprecated since Moment.js 1.6.0
    I: "", // no equivalent
    O: "", // no equivalent
    P: "", // no equivalent
    T: "", // no equivalent
    Z: "", // no equivalent
    c: "", // no equivalent
    r: "", // no equivalent
    U: "X"
  }
  return str.split('').map(chr => (chr in replacements ? replacements[chr] : chr)).join('')
}
//************************************/
export const humanizeDate = (date, isUtc = true, someElseFormat = 'L') => {
  date = isUtc ? moment.utc(date).local() : moment(date)
  const now = moment()
  const diffDays = date.diff(now, 'days')
  if (diffDays > -7) {
    return date.from(now, false)
  } else {
    return date.format(someElseFormat)
  }
}
//************************************/
/**
 *
 * @param date ISO 8601
 * @param format
 * @param isUtc
 * @returns {*}
 */
export const toLocalDateFormat = (date, format = 'L', isUtc = true) => {
  date = isUtc ? moment.utc(date) : moment(date)
  return date.local().format(format)
}
//************************************/
/**
 * @param date
 * @returns {*}
 */
export const ensureStartOfDay = (date) => {
  const _date = moment(date)
  const hasTime = _date.hour() || _date.minute() || _date.second()
  return hasTime
    ? _date.utc().format("YYYY-MM-DD HH:mm:ss")
    : _date.startOf("day").utc().format("YYYY-MM-DD HH:mm:ss")
}
//************************************/
/**
 * @param date
 * @returns {*}
 */
export const ensureEndOfDay = (date) => {
  const _date = moment(date)
  const hasTime = _date.hour() || _date.minute() || _date.second()
  return hasTime
    ? _date.utc().format("YYYY-MM-DD HH:mm:ss")
    : _date.endOf("day").utc().format("YYYY-MM-DD HH:mm:ss")
}
//************************************/
/**
 * use in _getAppSettings
 * @param phpDateFormat
 */
export const updateMomentDateLocale = (phpDateFormat) => {
  const lang = _getAppLang()
  const extraDefineLocale = lang === 'ar' ? {
    weekdaysMin: ['أح', 'إثن', 'ثل', 'اربع', 'خم', 'جمع', 'سبت'],
    meridiemParse: /AM|PM/,
    isPM: (input) => {
      return 'PM' === input
    },
    meridiem: (hour, minute, isLower) => {
      if (hour < 12) {
        return 'AM'
      } else {
        return 'PM'
      }
    },
    preparse: (string) => {
      const numberMap = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
      return string
        .replace(/[1234567890]/g, function (match) {
          return numberMap[match]
        })
        .replace(/،/g, ',')
    },
    postformat: (string) => {
      const symbolMap = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
      return string
        .replace(/\d/g, function (match) {
          return symbolMap[match]
        })
        .replace(/,/g, '،')
    }
  } : {}
  moment.updateLocale(lang, {
    longDateFormat: {
      LT: "h:mm A",
      LTS: "h:mm:ss A",
      L: phpToMomentFormat(phpDateFormat),
      LL: "L LT",
      LLL: "L LTS",
      LLLL: "dddd, MMMM Do YYYY LT",
      ISODATE: "YYYY-MM-DD"
    },
    ...extraDefineLocale
  })
}

export const isProduction = () => {
  return env('REACT_APP_ENV').trim().toLowerCase() === "production"
}

export const registerSyncFusionLicense = () => {
  registerLicense('ORg4AjUWIQA/Gnt2XFhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5WdkBjX3xZcn1SQ2RaWkd1')
  // registerLicense(env('REACT_APP_SYNCFUSION_LICENSE_KEY'))
}
//************************************/
/**
 * session storage
 */
export const getKeyFromSessionStorage = (key, defaultValue = null) => {
  return key ? sessionStorage.getItem(key) : defaultValue
}
export const removeKeyFromSessionStorage = (key) => {
  sessionStorage.removeItem(key)
}
export const setKeySessionStorage = (key, value) => {
  sessionStorage.setItem(key, value)
}
/**
 * work with url query string
 */
export const fetchQueryStringFromUrl = () => {
  return window.location.search
}
export const convertParamsToQueryString = (params, exactKeys = []) => {
  const paramsObj = _.pickBy(params, function (value, key) {
    return exactKeys.length > 0 ? _.includes(exactKeys, key) : true
  })
  return `?${qs.stringify(paramsObj)}`
}
export const changeUrlQuery = (params, exactKeys = [], history = null) => {
  const queryStringParams = convertParamsToQueryString(params, exactKeys)
  if (history) {
    const locationSearch = history.location.search
    if (locationSearch !== queryStringParams) {
      history.push(queryStringParams)
    }
  }
  return queryStringParams
}
export const fetchKeysFromQueryString = (queryString = '', exactKeys = [], customCallbacks = {}) => {
  const deepExtractKeys = {}
  const loopExactKeys = _.map(exactKeys, exactKey => {
    const splitExactKey = _.split(exactKey, ':')
    const key = splitExactKey[0]
    const deepKeys = splitExactKey[1]
    if (deepKeys) {
      deepExtractKeys[key] = _.split(deepKeys, ',')
    }
    return key
  })
  const queryStringParamsObject = qs.parse(queryString, { ignoreQueryPrefix: true })
  const paramsObj = _.pickBy(queryStringParamsObject, function (value, key) {
    return exactKeys.length > 0 ? _.includes(loopExactKeys, key) : true
  })
  if (!_.isEmpty(deepExtractKeys)) {
    _.map(deepExtractKeys, (keys, index) => {
      paramsObj[index] = _.pickBy(paramsObj[index], (value, key) => {
        return _.find(keys, (k, i) => {
          if (_.isArray(value)) {
            return k === key
          } else if (_.isObject(value)) {
            if (customCallbacks.deepExtractObjectKeyCallback) {
              return customCallbacks.deepExtractObjectKeyCallback({ queryStringKey: index, columsFiltersKeys: keys, queryStringParamObjectKey: key, queryStringParamObjectValue: value, targetKey: k })
            }
            const valueKeys = _.map(value, (v, k) => `${key}.${k}`)
            return _.includes(valueKeys, k)
          } else {
            return k === key
          }
        })
      })
    })
  }
  return paramsObj || {}
}

export const formatUserName = (user) => {
  let name = ''
  const splittedFirstName = user?.first_name ? user.first_name?.split(' ') : ['']
  const splittedLastName = user?.last_name ? user.last_name?.split(' ') : ['']
  const firstNameSize = _.size(splittedFirstName)
  const lastNameSize = _.size(splittedLastName)
  if (firstNameSize > 0 && lastNameSize > 0) {
    name = _.join([splittedFirstName[0][0], splittedLastName[0][0]], '')
  } else if (firstNameSize >= 2) {
    name = _.join([splittedFirstName[0][0], splittedFirstName[1][0]], '')
  } else if (lastNameSize >= 2) {
    name = _.join([splittedLastName[0][0], splittedLastName[1][0]], '')
  } else {
    name = splittedFirstName[0][0] ?? splittedLastName[0][0] ?? ''
  }
  return name
}

/*
 ** any: true -> must match any role
 ** any: false -> must match all roles
 */
export const hasRole = (roles = [], any = true) => {
  const inputRoles = typeof roles === 'string' ? [roles] : roles
  const user = getUserData()
  const userRoles = _.map(user.roles, role => role.code)
  const existsRoles = _.filter(inputRoles, role => {
    return _.includes(userRoles, role)
  })
  return any
    ? _.size(existsRoles) > 0
    : _.size(existsRoles) === _.size(roles)
}

export const validateURL = (url) => {
  try {
    new URL(url)
    return true
  } catch (error) {
    return trans("gen.validations.url")
  }
}

export const addDownloadParamToUrl = (url) => {
  // Parse the URL using URL object
  const parsedUrl = new URL(url)
  // Check if a download parameter already exists
  if (parsedUrl.searchParams.has('download')) {
    // Set download to 1 if it exists (might be 0)
    parsedUrl.searchParams.set('download', 1)
  } else {
    // Add the download parameter with value 1
    parsedUrl.searchParams.append('download', 1)
  }
  // Return the modified URL as a string
  return parsedUrl.toString()
}
//************************************/
export const getFeatures = () => {
  try {
    const { features } = require('@csrc/assets/data/constants')
    return features
  } catch (e) {
    return {
      imageMarker: undefined
    }
  }
}
//************************************/
export const getFeature = (featureKey) => {
  if (featureKey) {
    const features = getFeatures()
    const currentFeature = _.find(features, x => x.localKey === featureKey || x.key === featureKey)
    if (currentFeature) {
      const onlineFeature = _.get(store.getState(), `app.settings.app.plan.features.${currentFeature.key}`, null)
      if (onlineFeature) {
        return {
          ...currentFeature,
          ...onlineFeature
        }
      }
    }
  }
  return {}
}
//************************************/
export const checkFeatureAvailability = (featureKey) => {
  const feature = getFeature(featureKey)
  // return false
  // return true
  if (feature) {
    if (_.isBoolean(feature.value)) {
      return feature.value
    }
  }
  return true
}
//************************************/
export const validateInternationalAlpha = (string, message = trans('gen.validations.alpha')) => {
  const validate = !_.isNil(string?.match(/^[\p{Letter}\s\-']+$/u))
  return message ? (validate || message) : validate
}
//************************************/
export const validateEmail = (string, message = trans('gen.validations.email')) => {
  const validate = !_.isNil(string?.match(/^[\w-\.]+@([\w-]+\.)+[\w-]+/g))
  return message ? (validate || message) : validate
} 
export const validateNickName = (string, message = trans('gen.validations.nickName')) => {
  const validate = !_.isNil(string?.match(/^[a-zA-Z0-9_\-.@#$]+$/u))
  return message ? (validate || message) : validate
}
//************************************/
export const toBoolean = (boolean) => {
  if (typeof boolean === 'boolean') return boolean
  if (typeof boolean === 'string') return boolean.toLowerCase() === 'true'
  return false
}//************************************/
export const resolveAsset = (mod) => {
  return mod && mod.default ? mod.default : mod
}
